import "../styles/common.css";
import PageTemplate from "../templates/page-template";

export default function DonationPage() {
	return <PageTemplate header="Make a Donation" />;
}
